import { FORM_ERROR_PARTS } from './formErrorParts';
import type { FormErrorStyleConfig } from './types';

const BASE_STYLE = {
  text: {
    color: 'alert.error',
    fontFamily: 'default',
    fontSize: 'sm',
    fontWeight: 'default',
    lineHeight: 'sm',
    mt: 0.25,
  },
  icon: {},
} as const;

export const FORM_ERROR_STYLE_CONFIG: FormErrorStyleConfig = {
  parts: FORM_ERROR_PARTS,
  baseStyle: BASE_STYLE,
};
